import React from 'react';
import { NavLink } from 'react-router-dom';
import { AiOutlineMenu } from "react-icons/ai";

interface Props{
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
}


const Header = ({setOpen}:Props) => {
  return (
    <div className='navbar'>
      <div className='navbar-logo'>
        <img src='/LogoWhite.png' alt='Logo' />
      </div>

      <div className='navbar-routes'>
        <NavLink 
          to='/inicio' 
          className={({ isActive }) => `navbar-route ${isActive ? 'active' : ''}`}
        >
          Inicio<span></span>
        </NavLink>

        <NavLink 
          to='/galeria' 
          className={({ isActive }) => `navbar-route ${isActive ? 'active' : ''}`}
        >
          Galeria<span></span>
        </NavLink>
      </div>

      <div className='header-button' style={{opacity:"0"}}>
        <button className='button-card-armory'>Contactar</button>
      </div>

      <div className='Navbar-Menu'>
            <AiOutlineMenu onClick={()=>{setOpen(true)}} style={{cursor:"pointer", color:"#FFF"}} />
      </div>
    </div>
  );
};

export default Header;